import apiClient from './api-client';

export default {
  getUser() {
    return apiClient.get('/user');
  },
};
